<app-sm-nav></app-sm-nav>
<router-outlet></router-outlet>
<app-gainsight></app-gainsight>